export default __webpack_public_path__ + "static/media/dividend.4ee5695f.svg";